import { type RegisterButton, RegisterButtonState } from './TuitionAndRegistration.types';

type MixedScopeParams = {
    processingRegistration: boolean | undefined;
    registerRequiresRedirectToBrowser: boolean | undefined;
    defaultState: RegisterButtonState;
    additionalFinancingOptionIsSelected: boolean;
};

export function getRegisterButtonState({
    processingRegistration,
    registerRequiresRedirectToBrowser,
    defaultState,
    additionalFinancingOptionIsSelected,
}: MixedScopeParams): RegisterButtonState {
    if (registerRequiresRedirectToBrowser) {
        return RegisterButtonState.requires_redirect_to_browser;
    }

    if (processingRegistration) {
        return RegisterButtonState.processing;
    }

    if (additionalFinancingOptionIsSelected) {
        return RegisterButtonState.continue_to_register;
    }

    return defaultState;
}

type GetRegisterButtonProps = {
    registerButtonState: RegisterButtonState;
};

export function getRegisterButton({ registerButtonState }: GetRegisterButtonProps): RegisterButton {
    const configsByState: Record<RegisterButtonState, RegisterButton> = {
        processing: {
            registerButtonState: RegisterButtonState.processing,
            text: { key: 'settings.tuition_and_registration.processing' },
        },
        requires_redirect_to_browser: {
            registerButtonState: RegisterButtonState.requires_redirect_to_browser,
            text: { key: 'settings.tuition_and_registration.launch_browser' },
        },
        continue_to_register: {
            registerButtonState: RegisterButtonState.continue_to_register,
            text: { key: 'settings.tuition_and_registration.continue_to_register' },
        },
        review_and_register: {
            registerButtonState: RegisterButtonState.review_and_register,
            text: { key: 'settings.tuition_and_registration.review_and_register' },
        },
        register: {
            registerButtonState: RegisterButtonState.register,
            text: { key: 'settings.tuition_and_registration.register' },
        },
    };

    return configsByState[registerButtonState];
}
